export const fileSzeGenerator = (fileSizeInKB) => {
  if (fileSizeInKB < 1024) {
    return fileSizeInKB.toFixed(2) + ' KB'; // Display in KB for sizes less than 1 MB
  } else if (fileSizeInKB < 1024 * 1024) {
    return (fileSizeInKB / 1024).toFixed(2) + ' MB'; // Display in MB for sizes less than 1 GB
  } else {
    return (fileSizeInKB / (1024 * 1024)).toFixed(2) + ' GB'; // Display in GB for larger sizes
  }
};
